import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import AdminLayout from '../../components/admin/AdminLayout';
import { useAuth } from '../../context/AuthContext';

const StatCard = ({ icon, label, value, to, highlight }) => (
  <Link to={to} style={{ textDecoration: 'none' }}>
    <div style={{ background: '#fff', borderRadius: '10px', padding: '20px', border: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: '16px', cursor: 'pointer', transition: 'box-shadow 0.15s' }}>
      <div style={{ fontSize: '28px', width: '48px', height: '48px', background: '#f0f9ff', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{icon}</div>
      <div>
        <div style={{ fontSize: '24px', fontWeight: 700, color: highlight ? '#ef4444' : '#0f172a' }}>{value}</div>
        <div style={{ fontSize: '13px', color: '#64748b' }}>{label}</div>
      </div>
    </div>
  </Link>
);

const AdminDashboard = () => {
  const { admin } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get('/api/admin/stats').then(r => setStats(r.data.data)).catch(console.error);
  }, []);

  return (
    <AdminLayout>
      <div>
        <h1 style={{ fontSize: '22px', fontWeight: 700, color: '#0f172a', margin: '0 0 4px' }}>
          Welcome back, {admin?.displayName || admin?.username}
        </h1>
        <p style={{ color: '#64748b', fontSize: '14px', marginBottom: '28px' }}>
          Here's an overview of your site content.
        </p>

        {stats && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '16px', marginBottom: '32px' }}>
            <StatCard icon="🛠" label="Services" value={stats.services} to="/admin/services" />
            <StatCard icon="📁" label="Case Studies" value={stats.caseStudies} to="/admin/case-studies" />
            <StatCard icon="📰" label="News & Insights" value={stats.news} to="/admin/news" />
            <StatCard icon="🔗" label="Press References" value={stats.pressRefs} to="/admin/press-references" />
            <StatCard icon="👥" label="Team Members" value={stats.team} to="/admin/team" />
            <StatCard icon="💼" label="Career Listings" value={stats.careers} to="/admin/careers" />
            <StatCard icon="✉️" label="Contact Submissions" value={stats.contacts} to="/admin/contacts" />
            {stats.newContacts > 0 && (
              <StatCard icon="🔔" label="New Unread Messages" value={stats.newContacts} to="/admin/contacts" highlight />
            )}
          </div>
        )}

        <div style={{ background: '#fff', borderRadius: '10px', padding: '20px', border: '1px solid #e2e8f0' }}>
          <h2 style={{ fontSize: '15px', fontWeight: 600, color: '#0f172a', marginTop: 0 }}>Quick Links</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            {[
              { to: '/admin/news', label: '+ Add Insight' },
              { to: '/admin/press-references', label: '+ Add Press Reference' },
              { to: '/admin/case-studies', label: '+ Add Case Study' },
              { to: '/admin/services', label: '+ Edit Services' },
              { to: '/admin/careers', label: '+ Post Job' },
              { to: '/admin/contacts', label: 'View Messages' },
            ].map(({ to, label }) => (
              <Link key={to} to={to} style={{ background: '#f0f9ff', color: '#3b82f6', textDecoration: 'none', padding: '8px 16px', borderRadius: '6px', fontSize: '13px', fontWeight: 500 }}>
                {label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;
